module.exports = __webpack_public_path__ + "static/media/ifeno_logo.5bce7940.png";